<template>
  <div class="wrap">
    <v-data-table class="app-table" v-model="selected" :headers="headers" :items="data" :single-select="singleSelect" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="name" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')">
      <template v-slot:item.status="{ item }"><span>{{ getStatus(item.status) }}</span></template>
    </v-data-table>
    <div class="text-center mt-10">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import { RENTAL_STATUS } from '@/libs/enum'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: this.$t('tableRentals.headers.userName'), sortable: false, value: 'userName' },
        { text: this.$t('tableRentals.headers.userEmail'), sortable: false, value: 'userEmail' },
        { text: this.$t('tableRentals.headers.bikeID'), sortable: false, value: 'bikeID' },
        { text: this.$t('tableRentals.headers.status'), value: 'status' },
        { text: this.$t('tableRentals.headers.scheduleTime'), value: 'scheduleTime' },
        { text: this.$t('tableRentals.headers.updateAt'), value: 'updateAt' },
        { text: this.$t('tableRentals.headers.note'), sortable: false, value: 'note' }
      ]
    }
  },
  methods: {
    getStatus (status) {
      return this.$t(`rentalStatus.${RENTAL_STATUS[status]}`)
    }
  }
}
</script>
